import React, { ReactNode, useContext } from 'react';
import { Cookies } from 'utils/cookies';
import { RobotsContent } from '@navi-toolbox/seo/types/meta-tag/robots';
import { CategoryItem } from '../common/components/categories-list/types';
import { KV } from '../types/utils';

export type Catalogue = {
  loaded: boolean;
  error: boolean;
  data: CategoryItem[] | null;
};

export type Model = {
  loaded: boolean;
  error: boolean;
  data: ModelJson | null;
};

export type SEOProperties = {
  metadescription: string | null;
  metakeywords: string | null;
  seotext: string | null;
  pageTitle: string;
  h1: string;
  canonicalURL: string | null;
  seoTemplate: string;
  vanityPath: string | null;
  canonicalURLNeeded: boolean;
  templates?: {
    metadescription?: string;
    metakeywords?: string;
    seotext?: string;
    pageTitle?: string;
    h1?: string;
  };
  metaRobotsContent?: RobotsContent[];
};

export type Experiment = {
  internalId: string;
  externalId?: string;
};

export type Header = {
  advices: string;
  shops: string;
  suppliers: string;
  faq: string;
  home: string;
  shoppingList: string;
  hideMobileRegion?: string | null;
  hideBreadcrumbs: boolean;
  hideTopBanner?: string | null;
  logoutUrl: string;
  logoutResource: string;
  initUrl: string;
  forgotPassword: string;
  logoImage: string;
  faviconImage: string;
  linkToCompare: string;
  linkToSearch: string;
  cookieLink: string;
  linkToShoppingList: string;
  recaptchaPublicKey: string;
  refreshUrl: string;
  oauthProvider: string;
};

export type ModelJson = {
  properties: {
    title: string;
    regionId: string;
    familyId: string;
    hideBreadcrumbs: boolean;
    params: KV | null;
    sort: KV | null;
    facetWrapNumber: string;
    template: string;
  };
  header: Header;
  seoProperties: SEOProperties;
  experiments?: Experiment[];
  breadcrumbs: Breadcrumb[];
  analytics?: {
    gtmCode?: string;
    yaCode?: string;
  };
  warningMessage: string | null;
  BrandsCarousel?: {
    title: string;
    placementId: string;
  };
};

export type Breadcrumb = {
  label: string;
  link: string;
};

export type RouterInstance = {
  bundle: string;
  hash: string;
  params: KV;
  path: string;
  search: string;
  error?: never;
};

export type Store = {
  catalogue?: Catalogue;
  model?: Model;
  router?: RouterInstance;
  isBot?: boolean;
  uuid?: string;
  host?: string;
  cookie?: Cookies;
};

export type StoreContext = React.Context<Store | null>;

type Provider = { children: ReactNode; value: Store };

export const storeContext = React.createContext<Store>({});

export const useStoreContext = () => useContext(storeContext);

export const StoreProvider: React.FC<Provider> = ({ children, value }) => (
  <storeContext.Provider value={{ ...value }}>{children}</storeContext.Provider>
);
